import { faComment, faHeart, faRetweet } from '@fortawesome/pro-solid-svg-icons'
import { Card, CardHeader, Divider } from '@mui/material'
import { memo } from 'react'

import { formatTicks } from '../../util/string.helpers'
import SocialStats from '../common/SocialStats'
import Text from '../shared/text/Text'

const EarnedStats = ({ t, stats: { like, reply, repost }, symbol }) => {
  const stats = [
    {
      label: t('earn-via.likes'),
      icon: faHeart,
      value: `${formatTicks(like)} ${symbol}`
    },
    {
      label: t('earn-via.comments'),
      icon: faComment,
      value: `${formatTicks(reply)} ${symbol}`
    },
    {
      label: t('earn-via.reposts'),
      icon: faRetweet,
      value: `${formatTicks(repost)} ${symbol}`
    }
  ]
  const total = like + reply + repost
  return (
    <Card>
      <CardHeader
        title={t('earn-via.earned-via', { symbol })}
        subheader={t('earn-via.earned-via-desc', { symbol })}
      />
      <Text
        variant='h4'
        label={`${formatTicks(total)} ${symbol}`}
        sx={{ py: 1, pl: 3 }}
      />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <SocialStats data={stats} />
    </Card>
  )
}

export default memo(EarnedStats)
